//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { DateMixin } from '@/mixins/DateMixin';
export default {
  name: 'quarterSelect',
  mixins: [DateMixin],
  mounted: function mounted() {
    this.$emit("change", [this.quarterYear, this.quarterMonths]);
  },
  methods: {
    // 季度年变化
    handleChange: function handleChange(value) {
      this.quarterYear = value;
      this.$emit('change', [this.quarterYear, this.quarterMonths]);
    },
    // 季度变化
    handleMonthsChange: function handleMonthsChange(value) {
      this.quarterMonths = value;
      this.$emit('change', [this.quarterYear, this.quarterMonths]);
    }
  }
};